import React, { PureComponent } from "react";
import Page from "../Page";

export default class ClockedOrder extends PureComponent {
  render() {
    return (
      <Page
        toolBarTitle="Historique des tickets"
        pageTitle="Historique des tickets"
      />
    );
  }
}
